// extracted by mini-css-extract-plugin
export default {"modal":"AlertBox_modal__NzXCR","modalshow":"AlertBox_modalshow__d+l+P","modalcontent":"AlertBox_modalcontent__wiDxa","modalbutton":"AlertBox_modalbutton__pKdvP"};